const landingPageConstants: LandingPageConstants = {
  STORE_STANDARD_TAGGING_CAMPAIGNS: 'STORE_STANDARD_TAGGING_CAMPAIGNS',
  STORE_STANDARD_KEYWORD_GROUP: 'STORE_STANDARD_KEYWORD_GROUP',
};
type LandingPageConstants = {
  STORE_STANDARD_TAGGING_CAMPAIGNS: string;
  STORE_STANDARD_KEYWORD_GROUP: string;
};
export default landingPageConstants;
